import { render, staticRenderFns } from "./InformMan.vue?vue&type=template&id=c0fbca7c&scoped=true"
import script from "./InformMan.vue?vue&type=script&lang=js"
export * from "./InformMan.vue?vue&type=script&lang=js"
import style0 from "./InformMan.vue?vue&type=style&index=0&id=c0fbca7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fbca7c",
  null
  
)

export default component.exports